const LegalHero = ({ title, subtitle }) => {
	// Render
	return (
		<section className='hero-grid relative flex-start min-h-[360px] w-full border-b'>
			<div className='w-full py-20 z-1'>
				<div className='mx-auto px-3 max-w-lg'>
					<div className='relative w-full text-center gap-4'>
						<h1 className='type-display'>{title}</h1>
						<p className='text-foreground-body mx-auto max-w-3xl text-lg font-light text-foreground-body'>{subtitle}</p>
					</div>
				</div>
			</div>
		</section>
	);
};
export { LegalHero };
